export const aboutInfo = {
  brandName: "木瓜影院",
  slogan: "您的首选在线观影平台",
  founded: "2022年",
  intro: "木瓜影院成立于2022年，是国内领先的免费在线影视资源平台。自成立以来，我们始终秉持「让每个人都能轻松享受影视乐趣」的理念，为数百万用户提供了优质的影视内容导航服务。\n\n我们的团队由一群热爱影视的年轻人组成，来自互联网、传媒、影视等多个领域。我们深知影迷对优质内容的渴望，因此夜以继日地更新维护平台内容，确保用户能在第一时间看到最新的影视资源。\n\n目前，木瓜影院的影视库已经涵盖了电影、电视剧、综艺、动漫四大品类，收录超过10万部影视作品，日均服务用户超过50万人次。我们仍在不断优化产品体验，努力成为中文互联网上最好的免费影视平台。",
  features: [
    {
      title: "完全免费",
      description: "无需注册，无需付费，所有影视资源永久免费浏览",
      icon: "ri-money-dollar-circle-line"
    },
    {
      title: "海量资源",
      description: "收录超过10万部影视作品，涵盖全网热门内容",
      icon: "ri-database-2-line"
    },
    {
      title: "高清画质",
      description: "多条播放线路，支持1080P超清和4K蓝光画质",
      icon: "ri-4k-line"
    },
    {
      title: "极速更新",
      description: "热门内容24小时内同步更新，永不落伍",
      icon: "ri-flashlight-line"
    }
  ],
  stats: [
    { label: "影视资源", value: "100,000+" },
    { label: "日均用户", value: "500,000+" },
    { label: "更新速度", value: "24小时内" },
    { label: "用户好评", value: "98%" }
  ],
  testimonials: [
    {
      name: "王先生",
      role: "资深影迷",
      content: "木瓜影院是我用过最好的免费影视平台，资源全、更新快、画质好。现在已经推荐给身边所有朋友了！",
      rating: 5
    },
    {
      name: "李女士",
      role: "追剧达人",
      content: "作为追剧狂人，木瓜影院的更新速度让我非常满意。热门剧基本当天就能看到，不用像以前那样到处找资源。",
      rating: 5
    },
    {
      name: "张同学",
      role: "大学生",
      content: "学生党预算有限，木瓜影院完全免费的体验太棒了。而且手机浏览体验也很好，食堂排队的时候就能追一集。",
      rating: 5
    }
  ],
  contact: {
    email: "contact@muguayingyuan.com",
    wechat: "木瓜影院官方",
    weibo: "@木瓜影院",
    qq: "123456789",
    address: "北京市朝阳区望京SOHO T3 12层",
    workingHours: "周一至周日 9:00 - 21:00"
  }
};